module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2018_fr-eda71b1a045e77159e48932861efb6ed.jpg";